export default __webpack_public_path__ + "static/media/banner-checkout-builder.15d00ecc.png";